import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import template from "./../templates/bao-badge.html";
import css from "./../content/bao-badge.css";
$("head").append("<style>" + css + "</style>");
var vm = function (params) {
    var self = this;
    self.ReadOnly = ko.observable(false);
    self.ShowAll = ko.observable(false);
    self.Selection = ko.observable(null);
    self.UseSelection = ko.observable(false);
    self.Items = ko.observableArray();
    self.optionsText = "";
    self.optionsCss = "";
    self.itemSelected = function () { };
    self.deleteItem = function () { };
    self.Bao = Bao;
    if (params) {
        if (params.items) {
            if (ko.isObservable(params.items)) {
                self.Items = params.items;
            }
            else {
                self.Items(params.items);
            }
        }
        if (params.optionsText) {
            self.optionsText = ko.unwrap(params.optionsText);
        }
        if (params.optionsCss) {
            self.optionsCss = ko.unwrap(params.optionsCss);
        }
        if ($.isFunction(params.itemSelected)) {
            self.itemSelected = params.itemSelected;
        }
        if ($.isFunction(params.deleteItem)) {
            self.deleteItem = params.deleteItem;
        }
        if ($.isFunction(params.deleteAll)) {
            self.removeAll = params.deleteAll;
        }
        if (params.ReadOnly != undefined) {
            if (ko.isObservable(params.ReadOnly)) {
                self.ReadOnly = params.ReadOnly;
            }
            else {
                self.ReadOnly(params.ReadOnly);
            }
        }
        if (params.UseSelection != undefined) {
            if (ko.isObservable(params.UseSelection)) {
                self.UseSelection = params.UseSelection;
            }
            else {
                self.UseSelection(params.UseSelection);
            }
        }
    }
    if ($.isFunction(self.itemSelected)) {
        self.Selection.subscribe(self.itemSelected);
    }
    self.Items.Badged = ko.computed(function () {
        var items = self.Items();
        if (self.ShowAll()) {
            return items;
        }
        else {
            return items.slice(0, 9);
        }
    });
};
vm.prototype.removeItem = function (item, event) {
    event.stopPropagation();
    this.deleteItem(item, event);
};
vm.prototype.setSelection = function (item, event) {
    if (this.UseSelection()) {
        if (this.Selection() !== item) {
            this.Selection(item);
        }
        else {
            this.Selection(null);
        }
    }
};
vm.prototype.setShowAll = function () {
    this.ShowAll(!this.ShowAll.peek());
};
vm.prototype.removeAll = function (vm, event) {
    var items = this.Items(), itemsCount = items.length, index = 0;
    while (items.length > 0) {
        if (items[index]) {
            this.deleteItem(items[index], event);
            if (items.length === itemsCount) {
                index++;
            }
        }
        else {
            break;
        }
    }
};
export default {
    viewModel: vm,
    template: template
};